<template>
  <div>
    <loader :loading="loading"/>
    <div v-if="!loading">
      <header class="c-toolbar" v-if="!loading">
        <div class="l-level">
          <div class="l-level__left">
            <img :src="module.logo" class="logo" alt="">
            <h1 class="c-toolbar__title title">Editar produto</h1>
          </div>
        </div>
      </header>

      <div v-if="product">
        <component :is="productProvideEdit" ref="productProvideEditProduct" :product="product"/>
      </div>

      <panel>
        <button class="btn btn--success" @click="save">{{ $t('save.label') }}</button>
      </panel>
    </div>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import api from '@/api'
  import { upperFirst } from 'lodash'
  import notifier from '@/notifier'
  import Loader from '@/components/template/Loader'
  import Panel from '@/components/template/Panel'
  import FormGroup from '@/components/template/FormGroup'
  import PageTitle from '@/components/template/PageTitle'
  import ProductProvideEditTiny from '@/components/ProductProvide/Edit/Tiny/Product'
  import ProductProvideEditFlexy from '@/components/ProductProvide/Edit/Flexy/Product'
  import ProductProvideEditApi from '@/components/ProductProvide/Edit/Api/Product'
  import ProductProvideEditMoovin from '@/components/ProductProvide/Edit/Moovin/Product'
  import ProductProvideEditEcomece from '@/components/ProductProvide/Edit/Ecomece/Product'

  export default {
    data: () => ({
      loading: false,
      route: null
    }),
    props: {
      type: {
        type: String,
        required: true
      },
      identifier: {
        type: String,
        required: true
      },
      productId: {
        type: String,
        required: true
      }
    },
    updated () {
      const route = this.$router.history.current.path
      if (this.route === route) {
        return
      }

      this.clearErrors()

      this.route = route
    },
    methods: {
      ...mapActions('products', [
        'addItem'
      ]),
      ...mapActions('errors', [
        'clearErrors',
        'addError'
      ]),
      save () {
        this.clearErrors()
        this.loading = true

        const formattedProduct = this.$refs.productProvideEditProduct.formatProduct()

        api.updateProduct(this.type, this.identifier, formattedProduct)
          .then(() => {
            notifier.success('Produto atualizado com sucesso', 'Atualizado')
          })
          .catch(exception => {
            notifier.error('Erro ao atualizar produto', 'Falha')

            for (let i in exception.response.data.data) {
              const error = exception.response.data.data[i]

              let property = error.property
              let sku
              if (error.pointer.split('/')[1] === 'variations') {
                sku = formattedProduct.variations[error.pointer.split('/')[2]].sku
                property = error.property.split('.')[1]
              }

              this.addError({
                productId: formattedProduct.productId,
                sku: sku,
                property: property,
                error: {
                  message: error.constraint,
                  value: error[error.constraint]
                }
              })
            }
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
    computed: {
      ...mapGetters('products', [
        'getByProductId'
      ]),
      ...mapGetters('module', [
        'getDefinitionModuleByIdentifierAndType'
      ]),
      module () {
        return this.getDefinitionModuleByIdentifierAndType(this.type, this.identifier)
      },
      productProvideEdit () {
        return `ProductProvideEdit${upperFirst(this.identifier)}`
      },
      product () {
        let product = this.getByProductId(this.productId)
        if (product !== undefined) {
          return product
        }

        this.addItem({ type: this.type, identifier: this.identifier, productId: this.productId })
          .catch(() => {
            this.$router.push(`/${this.type}/${this.identifier}/products`)
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
    components: {
      PageTitle,
      Loader,
      Panel,
      FormGroup,
      ProductProvideEditTiny,
      ProductProvideEditFlexy,
      ProductProvideEditApi,
      ProductProvideEditMoovin,
      ProductProvideEditEcomece
    }
  }
</script>

<style lang="sass" scoped>
  .logo
    max-height: 30px

  .title
    margin-left: 20px

  .i-arrow
    font-size: 20px
    margin: 0 20px
</style>



// WEBPACK FOOTER //
// Edit.vue?4d5a4794